export function get() {
    try {
        const previousSearchValuesString = localStorage.getItem('previousSearchValues');
        const previousSearchValues = previousSearchValuesString
            ? JSON.parse(previousSearchValuesString)
            : [];
        return previousSearchValues;
    }
    catch (_a) {
        return [];
    }
}
export function update(query) {
    const previousSearchValues = get();
    previousSearchValues.unshift(query);
    const updatedSearchValues = Array.from(new Set([...previousSearchValues.slice(0, 5)]));
    localStorage.setItem('previousSearchValues', JSON.stringify(updatedSearchValues));
}
//# sourceMappingURL=previousSearch.js.map